import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translation_en from "../locales/en/translation.json";
import translation_fr from "../locales/fr/translation.json";

const resources = {
    en: {
        translation: translation_en,
    },
    fr: {
        translation: translation_fr,
    }
};

i18n.use(initReactI18next).init({
    resources: resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;